<!-- 这是下载页面 -->
<template>
    <div class="download">
        <div class="template-head">
        <div class="box">
            <div class="l">
            <a>
                <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" d="M0,0h40v40H0V0z"></path>
                <g>
                    <path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335"></path>
                    <path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04"></path>
                    <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4"></path>
                    <path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853"></path>
                </g>
                </svg>
                <h1>Google Play</h1></a>
            </div>
            <div class="r">
            <a>
                <img width="24" src="./imgs/search.svg" alt="">
            </a>
            <a> <img width="24" src="./imgs/help.svg" alt=""></a>
            <a> <img src="./imgs/avatar.png" alt=""></a>
            </div>
        </div>
        </div>
        <div class="template-bd">
            <div class="main-up">
                <div class="logo">
                    <div class="box"></div>
                    <img src="./imgs/192.png" alt="705 BET - Slots Online">
                </div>
                <div class="info">
                    <h1>Komodo9<img src="./imgs/ic_tag.png"></h1>
                    <h2>Kasino Live dan Slot Paling Tepercaya Di Indonesia</h2>
                    <p><img src="./imgs/ic_dun.png">Diverifikasi oleh Aplikasi</p>
                </div>
            </div>
            <ul class="information-list">
                <li>
                    <strong>
                        5.0
                        <img src="./imgs/start.png" alt="">
                    </strong>
                    <p>9.5K Ulasan</p>
                </li>
                <li>
                    <strong>1000K +</strong>
                    <p>Unduhan</p>
                </li>
                <li>
                    <strong><img class="large" src="./imgs/18.svg"></strong>
                    <p>Diperingkat untuk 18+</p>
                </li>
            </ul>

            <div class="btn-box shiny">
                <button id="reInstall" class="btn downloadButton" :data-clipboard-text="JSON.stringify(clipboardText)">Memasang</button>

                <!-- <div id="installing" class="btn">
                    <div id="proess"></div>
                    <span id="count">0</span><span>%</span>
                </div> -->

                <!-- <button id="play" onclick="playClick()" class="btn">Play</button> -->
            </div>
        <ul class="google-share-btns">
            <li class="downloadButton" :data-clipboard-text="JSON.stringify(clipboardText)">
                <svg class="f70z8e" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"></path>
                </svg>
                <span>Bagikan</span>
            </li>
            <li class="downloadButton" :data-clipboard-text="JSON.stringify(clipboardText)">
                <svg class="XkAcee" width="24" height="24" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z"></path>
                </svg>
                <span>Tambahkan ke daftar keinginan</span>
            </li>
        </ul>
        <div class="banner-imgs-box ">
            <ul class="banner-imgs">

                <li><img src="./imgs/1.jpg" alt=""></li>

                <li><img src="./imgs/2.jpg" alt=""></li>

                <li><img src="./imgs/3.jpg" alt=""></li>

                <li><img src="./imgs/4.jpg" alt=""></li>

                <li><img src="./imgs/5.jpg" alt=""></li>

                <li><img src="./imgs/6.jpg" alt=""></li>

            </ul>
        </div>

        <div class="introduce">
            <h2>Tentang aplikasi ini</h2>
            <div>Selamat datang di permainan slot online Komodo9 terbaik yang pernah ada! Mulailah bersenang-senang sekarang juga, dan ada banyak keuntungan slot yang menunggu Anda - putar untuk menang!
              <br>
              <br>
              Mainkan slot PG PP MG 777 yang paling gacor dan banyak pecahannya Ini adalah permainan slot online yang bergerak cepat dengan banyak kesenangan dan lebih dari 3.000 permainan slot!
              <br>
              Kehabisan Saldo? Klaim keuntungan harian Anda sekarang dan terus mainkan permainan slot online terbaik ini. Dari slot klasik hingga slot modern, ada banyak hal yang bisa Anda mainkan untuk kesenangan tanpa akhir!
              <br>
              <br>
              Mainkan permainan slot terbaik ini dengan teman-teman Anda! Dengan grafis 3D plus musik yang luar biasa, Anda pasti akan tenggelam dalam permainan slot Komodo9 Casino yang otentik ini ★!
            </div>
        </div>
        <div class="update-box">
            <h3>Diperbarui pada</h3>
            <p>Oct 13, 2024</p>
        </div>
        <div class="introduce data-safety-box">
            <h2>Keamanan Data</h2>
            <p>Keamanan dimulai dengan memahami bagaimana pengembang mengumpulkan dan berbagi data Anda. Praktik privasi dan keamanan data mungkin bervariasi berdasarkan penggunaan, wilayah, dan umur Anda. Pengembang memberikan informasi ini dan mungkin memperbarui informasi ini dari waktu ke waktu.</p>
        </div>
        <div class="data-safety-list">
            <ul>
            <li>
                <img src="./imgs/google/1.png" alt="">
                <div>Tidak ada data yang dibagikan dengan pihak ketiga</div>
            </li>
            <li>
                <img src="./imgs/google/2.png" alt="">
                <div>Aplikasi ini mungkin mengumpulkan jenis data ini</div>
            </li>
            <li>
                <img src="./imgs/google/3.png" alt="">
                <div>Data terenkripsi saat dalam transmisi</div>
            </li>
            <li>
                <img src="./imgs/google/4.png" alt="">
                <div>Anda dapat meminta penghapusan data</div>
            </li>
            </ul>
            <p>Lihat detail</p>
        </div>
        </div>
        <div class="comments" id="rb-comment">
          <div class="comments__title">Peringkat dan Ulasan</div>
          <div class="comments__tips">Peringkat dan ulasan telah terverifikasi dan dari orang-orang yang menggunakan perangkat yang sama dengan yang Anda gunakan</div>

          <div class="comments__type">
            <div class="comments__type-item comments__type-active">
              <img loading="lazy" src="./imgs/telephone.png" alt="">
              Telepon
            </div>
            <div class="comments__type-item">
              <img loading="lazy" src="./imgs/tablet.png" alt="">
              Tablet
            </div>
          </div>


          <div class="comments__scoring">
            <div class="comments__scoring-num">
              <div class="comments__scoring-points">4.5</div>
              <div class="comments__scoring-star">

                <img class="star" src="./imgs/start_1.png" style="width: 14px; height: 14px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 14px; height: 14px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 14px; height: 14px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 14px; height: 14px; margin-right: 2px;">
                <img class="star" src="./imgs/start_2.png" style="width: 14px; height: 14px; margin-right: 2px;">


              </div>
              <div class="comments__scoring-people">9.3K reviews</div>
            </div>
            <div class="comments__scoring-content">
              <div class="comments__scoring-item">5
                <div class="progress"><div class="progress-bar" style="width: 90%;"></div></div>
              </div>

              <div class="comments__scoring-item">4
                <div class="progress"><div class="progress-bar" style="width: 60%;"></div></div>
              </div>

              <div class="comments__scoring-item">3
                <div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>
              </div>

              <div class="comments__scoring-item">2
                <div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>
              </div>

              <div class="comments__scoring-item">1
                <div class="progress"><div class="progress-bar" style="width: 0%;"></div></div>
              </div>
            </div>
          </div>


          <div id="rb-comment-list">


            <div class="comments__list-item">
              <div class="comments__list-header">
                <img loading="lazy" class="comments__list-avatar" src="https://store.googlepwa.app/upload/images/2024-10-01/n3v1lQCrVTVlu2uzwf1S4kTeirZVCZGJ5CH1j882.png" alt="">
                <div class="comments__list-name">Tasya</div>
                <img loading="lazy" class="comments__list-icon" src="./imgs/more.png" alt="">
              </div>
              <div class="comments__list-stars">

                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <span>Oct 01, 2024</span>

              </div>
              <div class="comments__list-detail">Betul gem ini menghasil kan uang ka....</div>
            </div>


            <div class="comments__list-item">
              <div class="comments__list-header">
                <img loading="lazy" class="comments__list-avatar" src="https://store.googlepwa.app/upload/images/2024-10-01/ogTeSGTDbFWLSGIcM4vxGEDZLXPWH8QRWPdvSaUJ.png" alt="">
                <div class="comments__list-name">Maria</div>
                <img loading="lazy" class="comments__list-icon" src="./imgs/more.png" alt="">
              </div>
              <div class="comments__list-stars">

                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <span>Oct 01, 2024</span>

              </div>
              <div class="comments__list-detail">Game emas asli yang sangat menarik, sangat menyenangkan, mudah memenangkan hadiah</div>
            </div>


            <div class="comments__list-item">
              <div class="comments__list-header">
                <img loading="lazy" class="comments__list-avatar" src="https://store.googlepwa.app/upload/images/2024-10-01/shgPEbdUr5Q5XdwbXoAW77F1QWrhX643acqhegXl.png" alt="">
                <div class="comments__list-name">Syahrul</div>
                <img loading="lazy" class="comments__list-icon" src="./imgs/more.png" alt="">
              </div>
              <div class="comments__list-stars">

                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <img class="star" src="./imgs/start_1.png" style="width: 11px; height: 11px; margin-right: 2px;">
                <span>Oct 01, 2024</span>

              </div>
              <div class="comments__list-detail">Sangat mudah untuk menang, saya bermain selama beberapa hari untuk mendapatkan 100.000.000, sangat layak untuk direkomendasikan kepada teman-teman!</div>
            </div>


          </div>

          <div class="comments__br"></div>
        </div>
        <div class="template-footer">
        <ul>
            <li>
            <a>
                <p><img width="24" src="./imgs/game.svg" alt=""></p>
                <span>Game</span></a>
            </li>
            <li class="active">
            <a>
                <p><img width="24" src="./imgs/app.svg" alt=""></p>
                <span>Aplikasi</span></a>
            </li>
            <li>
            <a>
                <p><img width="24" src="./imgs/file.svg" alt=""></p>
                <span>Film</span></a>
            </li>
            <li>
            <a>
                <p><img width="24" src="./imgs/book.svg" alt=""></p>
                <span>Buku</span></a>
            </li>
            <li>
            <a>
                <p><img width="24" src="./imgs/child.svg" alt=""></p>
                <span>Anak-anak</span>
            </a>
            </li>
        </ul>
        </div>
        <div class="ios-guide" v-if="isIOS">
            <div class="content">
                <div class="tips">
                    <div class="tips-text">
                        <div class="main-tips">Guia de instalação do WebAPP</div>
                    </div>
                </div>
                <ul class="guide-step">
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 1</div>
                        </div>
                        <div class="m-title">Clique em "Ajustes" no seu telefone</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/1.png" class="van-image__img">
                        </div>
                    </li>
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 2</div>
                        </div>
                        <div class="m-title">Clique em "Geral" para entrar nas configurações gerais</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/2.png" class="van-image__img">
                        </div>
                    </li>
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 3</div>
                        </div>
                        <div class="m-title">Clique em "Gestão de VPN e Dispostitivo"</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/3.png" class="van-image__img">
                        </div>
                    </li>
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 4</div>
                        </div>
                        <div class="m-title">Clique em "PERFIL BAIXADO : KKGG.com"</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/4.png" class="van-image__img">
                        </div>
                    </li>
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 5</div>
                        </div>
                        <div class="m-title">Clique em "Instalar" no canto superior direito e verifique sua senha</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/5.png" class="van-image__img">
                        </div>
                    </li>
                    <li class="item">
                        <div class="step-bg">
                            <div class="step-num">Passo 6</div>
                        </div>
                        <div class="m-title">Clique em [Instalar] na parte inferior e retorne à área de trabalho para abrir o aplicativo.</div>
                        <div class="mt-40 van-image" style="width: 100%;">
                            <img src="./img/6.png" class="van-image__img">
                        </div>
                    </li>
                </ul>
            </div>
            <div class="fixed-bottom">
                <div class="fixed-content">
                    <img src="./imgs/192.png">
                    <div class="handle">
                        <a href="javascript:;" class="btn-ios downloadButton">Baixe Agora</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import ClipboardJS from 'clipboard'
import config from './config'
import utils from "@/global/js/utils"
import downloadApp from "../../../global/downloadApp"

const isAndroid = () => {
  let ua = navigator.userAgent.toLowerCase()
  if (/android/.test(ua)) {
    return true
  }
  return false
}

const isIOS = () => {
  let ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) {
    return true
  }
  return false
}
export default {
  data() {
    return {
      isAndroid: isAndroid(),
      isIOS: isIOS(),
      config
    }
  },
  computed: {
    downloadPage() {
      return config.downloadPage
    },
    clipboardText() {
      let appid = ''
      if (this.isAndroid) {
        appid = this.downloadPage.andAppid
      } else if (this.isIOS) {
        appid = this.downloadPage.iosAppid
      }
      return {
        appid,
        code: this.downloadPage.code,
        channelCode: this.downloadPage.channelCode
      }
    }
  },
  methods: {
    clipboardFunc(id, cb) {
      var clipboard = new ClipboardJS('#' + id)
      clipboard.on('success', function (e) {
        console.info('Action:', e.action)
        console.info('Text:', e.text)
        console.info('Trigger:', e.trigger)
        e.clearSelection()
        cb && cb()
      })

      clipboard.on('error', function (e) {
        console.error('Action:', e.action)
        console.error('Trigger:', e.trigger)
        alert('操作失败，请重新尝试')
      })
    },
    // openinstall的逻辑，安装ipa/apk或者唤醒的时候带入邀请码参数
    openInstallInit() {
      const _this = this
      window.onload = function () {
        //openinstall初始化时将与openinstall服务器交互，应尽可能早的调用
        /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
        var data = OpenInstall.parseUrlParams();//openinstall.js中提供的工具函数，解析url中的所有查询参数
        new OpenInstall({
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: config.install[config.install.used].key,
          /*可选参数，自定义android平台的apk下载文件名；个别android浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
          //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
          /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
          //preferWakeup:true,
          /*自定义遮罩的html*/
          mask: function () {
            return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          },
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this;
            var buttons = document.getElementsByClassName('downloadButton')
            for (var i = 0; i < buttons.length; i++) {
              buttons[i].style.visibility = "visible";
              /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
              buttons[i].onclick = function (e) {
                // if (location.search.indexOf('?code=') >= 0) {
                //     m.wakeupOrInstall();
                // } else {
                //     alert('网络延迟，请稍等')
                // }
                m.wakeupOrInstall();
                return false;
              }
            }
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
          }
        }, data);
      }
    },
    shareInstallInit() {
      const _this = this
      window.onload = function () {
        // shareinstall初始化，初始化时将与shareinstall服务器交互，应尽可能早的调用
        /* web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据 */
        /**
         * shareinstall的data不允许为空对象
         */
        const data = ShareInstall.parseUrlParams(); // shareinstall.js中提供的工具函数，解析url中的所有查询参数
        new ShareInstall({
          appKey: config.install[config.install.used].key,
          // 可选项，微信中打开自定义遮罩层
          // shadow: function(){
          //  return "<div id='shareinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          // },
          /* 可选参数，是否优先考虑拉起app，以牺牲下载体验为代价 */
          // preferWakeup: true,
          /* 可选参数，唤醒操作的执行时长，超时后将放弃唤醒并执行下载，默认1500，单位是毫秒 */
          // timeout: 1500,
          onready: function () {
            // shareinstall已成功回调
            const m = this;
            const buttons = document.getElementsByClassName("downloadButton");
            for (let i = 0; i < buttons.length; i++) {
              buttons[i].style.visibility = "visible";
              /* 用户点击某个按钮时(假定按钮id为downloadButton)，安装app */
              buttons[i].onclick = function (e) {
                const id = e.currentTarget.id
                const code = (e.currentTarget.href && e.currentTarget.href.split('code=')[1]) ? e.currentTarget.href.split('code=')[1] : _this.clipboardText.code
                const clipboard = _this.clipboardText.appid && code
                if (clipboard) {
                  _this.clipboardFunc(id, () => {
                    m.wakeupOrInstall();
                  })
                } else {
                  m.wakeupOrInstall();
                }
              }
            }
          }
        }, data);
      }
    },
    ShareTraceInit() {
      ShareTrace.init(config.install.shareTraceInstall.key)
      const buttons = document.getElementsByClassName("downloadButton");
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].style.visibility = "visible";
        const _this = this
        buttons[i].onclick = function (e) {
          const id = e.currentTarget.id
          const code = (e.currentTarget.href && e.currentTarget.href.split('code=')[1]) ? e.currentTarget.href.split('code=')[1] : _this.clipboardText.code
          const clipboard = _this.clipboardText.appid && code
          if (clipboard) {
            _this.clipboardFunc(id, () => {
              ShareTrace.download();
            })
          } else {
            ShareTrace.download();
          }
        }
      }
    }
  },
  beforeCreate: function () {
    if (config.install.used === 'openinstall') {
      // 在这儿引入外部 openinstall
      const oiJS = document.createElement('script');
      oiJS.type = 'text/javascript';
      oiJS.src = 'https://web.cdn.openinstall.io/openinstall.js';
      document.body.appendChild(oiJS);
    } else if (config.install.used === 'shareinstall') {
      // 在这儿引入外部 shareinstall
      const siJS = document.createElement('script');
      siJS.type = 'text/javascript';
      siJS.src = 'https://www.shareinstall.com.cn/js/page/jshareinstall.min.js';
      document.body.appendChild(siJS);
    } else if (config.install.used === 'shareTraceInstall') {
      // 在这儿引入外部 shareinstall
      const stJS = document.createElement('script');
      stJS.type = 'text/javascript';
      stJS.src = "https://res.sharetrace.com/sharetrace.min.js";
      document.body.appendChild(stJS);
    }
  },
  mounted() {
    this.$nextTick(() => { // 在dom渲染完后,再执行动画
      var wow = new WOW({
        live: false
      })
      wow.init()
    })

    if (config.install.used === 'tenant') { // 租户自己的
      const buttons = document.getElementsByClassName('downloadButton')
      for (let i = 0; i < buttons.length; i++) {
        const _this = this
        buttons[i].onclick = function (e) {
          const id = e.currentTarget.id
          const code = (e.currentTarget.href && e.currentTarget.href.split('code=')[1]) ? e.currentTarget.href.split('code=')[1] : _this.clipboardText.code
          const clipboard = _this.clipboardText.appid && code
          const isIos = isIOS()
          let tenantUrl = !isIos ? config.install.tenant.androidURL : config.install.tenant.iosURL
          if (clipboard) {
            _this.clipboardFunc(id, () => {
              downloadApp(tenantUrl)
            })
          } else {
            if (isIos) {
              downloadApp(`${tenantUrl}`)
              setTimeout(() => {
                downloadApp('/app.mobileprovision')
              }, 2000)
            } else {
              downloadApp(tenantUrl)
            }
          }
        }
      }
    } else if (config.install.used === 'openinstall') { // openinstall 配置的
      this.openInstallInit()
    } else if (config.install.used === 'shareinstall') { // shareinstall 配置的
      this.shareInstallInit()
    } else if (config.install.used === 'shareTraceInstall') { // ShareTrace 配置的\
      let that = this;
      window.addEventListener('load', function () {
        that.ShareTraceInit()
      })
    }

    // this.openInstallInit()
    // // 检测是否是带code的地址
    // const hasCode = location.search.indexOf('?code=') >= 0
    // if (!hasCode) { // 纯静态页的
    //     document.location.replace(`${location.origin}${location.pathname}?code=${config.downloadPage.code}`)
    // }
    /**
     * 1、config中的channelCode是可配置的，
     * 2、url中 有code不补；无code补code；在config有channelCode的话，有则补补，无则补
     */
    const searchStr = location.search.slice(1, location.search.length)
    let searchJSON = {}
    if (searchStr) {
      searchJSON = utils.parseQueryString(searchStr)
    }
    if (searchJSON.code && searchJSON.channelCode || (searchJSON.code && !config.downloadPage.channelCode)) {
      return
    }
    if (!searchJSON.code) {
      searchJSON.code = config.downloadPage.code
    }
    if (!searchJSON.channelCode && config.downloadPage.channelCode) {
      searchJSON.channelCode = config.downloadPage.channelCode
    }
    if (!searchJSON.code) {
      return
    }
    let replaceURL = `${location.origin}${location.pathname}?code=${searchJSON.code}`
    if (searchJSON.channelCode) {
      replaceURL += `&channelCode=${searchJSON.channelCode}`
    }
    document.location.replace(replaceURL)
  }
}
</script>

<style scoped></style>
